import React from 'react';
import PdfToReactFormGenerator from '../../../components/common/Forms/PdfToReactFormGenerator';
import { ProtectedRoute, PageGuard } from '../../../components/common/security/ProtectedRoute';

const ToFormsCreate: React.FC = () => {
  return (
    <ProtectedRoute>
      <PageGuard>
        <div style={{ padding: 24 }}>
          <PdfToReactFormGenerator />
        </div>
      </PageGuard>
    </ProtectedRoute>
  );
};

export default ToFormsCreate;
